document.addEventListener('DOMContentLoaded', function () {

  /* Header scroll shadow */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    }, { passive: true });
  }

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Mobile nav toggle */
  var navToggle = document.querySelector('.mobile-nav-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileNavClose = document.querySelector('.mobile-nav__close');
  function toggleMobileNav(open) {
    if (!mobileNav) return;
    mobileNav.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (navToggle) navToggle.addEventListener('click', function () { toggleMobileNav(true); });
  if (mobileNavClose) mobileNavClose.addEventListener('click', function () { toggleMobileNav(false); });
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { toggleMobileNav(false); });
    });
  }

  /* Search overlay */
  var searchOverlay = document.getElementById('SearchOverlay');
  var searchInput = document.getElementById('SearchOverlayInput');
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    if (searchInput) searchInput.focus();
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-search-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSearch(); });

  /* Tabs (featured collection category switch) */
  document.querySelectorAll('.tab-bar').forEach(function (bar) {
    var target = document.querySelector(bar.dataset.target);
    if (!target) return;
    var viewAllLink = bar.dataset.viewAll ? document.getElementById(bar.dataset.viewAll) : null;
    bar.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        bar.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var group = btn.dataset.group;
        target.querySelectorAll('[data-group-item]').forEach(function (item) {
          var show = group === 'all' || item.dataset.groupItem === group;
          item.style.display = show ? '' : 'none';
        });
        if (viewAllLink && btn.dataset.url) {
          viewAllLink.setAttribute('href', btn.dataset.url);
        }
      });
    });
  });

  /* Wishlist heart toggle (local, visual only) */
  document.querySelectorAll('.product-card__wishlist').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('is-active');
    });
  });

  /* -------- Cart drawer (Shopify AJAX Cart API) -------- */
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-drawer-overlay');
  var drawerBody = document.querySelector('.cart-drawer__body');
  var drawerCount = document.querySelectorAll('.cart-count');
  var drawerSubtotal = document.querySelector('.cart-drawer__subtotal-amount');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); refreshCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }

  function refreshCart() {
    if (!drawerBody) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderCart(cart) {
    drawerCount.forEach(function (el) { el.textContent = cart.item_count; });
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    if (!drawerBody) return;
    if (!cart.items.length) {
      drawerBody.innerHTML = '<p style="text-align:center;padding:60px 0;opacity:.6;">Your bag is feeling light. Time to add a little luxury.</p>';
      return;
    }
    drawerBody.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-line" data-key="' + item.key + '">' +
        '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
        '<div class="cart-line__info">' +
          '<h5>' + item.product_title + '</h5>' +
          '<span>' + (item.variant_title || '') + '</span><br>' +
          '<span>' + money(item.final_line_price) + '</span>' +
          '<div class="cart-drawer__stepper" style="display:flex;align-items:center;gap:10px;margin-top:8px;">' +
            '<button type="button" class="cart-drawer__step" data-cart-change data-key="' + item.key + '" data-step="-1" aria-label="Decrease quantity" style="width:26px;height:26px;border-radius:50%;border:1px solid rgba(36,26,27,.2);background:transparent;cursor:pointer;">&minus;</button>' +
            '<span class="cart-drawer__qty">' + item.quantity + '</span>' +
            '<button type="button" class="cart-drawer__step" data-cart-change data-key="' + item.key + '" data-step="1" aria-label="Increase quantity" style="width:26px;height:26px;border-radius:50%;border:1px solid rgba(36,26,27,.2);background:transparent;cursor:pointer;">&plus;</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-change]');
      if (!btn) return;
      var qtyEl = btn.parentElement.querySelector('.cart-drawer__qty');
      var newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(btn.dataset.step, 10));
      changeCartItem(btn.dataset.key, newQty);
    });
  }

  /* Intercept product form add-to-cart to open drawer via AJAX */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(); openDrawer(); })
      .catch(function () { form.submit(); });
  });

  /* Quick-add buttons on product cards */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.quickAdd;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function (r) { return r.json(); })
        .then(function () { refreshCart(); openDrawer(); });
    });
  });

  refreshCart();
});